import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import $ from 'jquery';

let occupation = {
  8080: 'Businessman',
  8081: 'Salaried',
  8082: 'Self employed',
  8083: 'Retiree',
  8084: 'Student',
  8085: 'Housewife',
  8086: 'Armed police personnel (Police, Army etc.)',
  8087: 'Government employee',
  8088: 'Professional worker (farmer, teacher, engineer, doctor, lawyer etc.)',
  8089: 'Unemployed',
};

let sourceOfFund = {
  8051: 'Salary',
  8052: 'Business',
  8070: 'Salary / Wages',
  8071: 'Bonus / Commission',
  8073: 'Savings or accumulated',
  8074: 'Part time job',
  8075: 'Own business',
  8076: 'Investment',
  8077: 'Lottery',
  8078: 'Gifts and donation',
  8079: 'Loan from bank',
};

function ImeMoneyKycTransfer() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [data, setData] = useState(false);
  const [customerStatus, setCustomerStatus] = useState(false);
  const [mobileNumber, setMobileNumber] = useState(false);
  const [base64, setBase64] = useState(false);
  const [idProof, setIdProof] = useState(false);
  const [processId, setProcessId] = useState('');
  const [searchBy, setSearchBy] = useState("mobile");
  const [showModal, setShowModal] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [addReceiverModal, setAddReceiverModal] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [paymentData, setPaymentData] = useState(false);
  const [bankName, setBankName] = useState(false);
  const [bankBranchName, setBankBranchName] = useState(false);
  const [states1, setStates1] = useState(false);
  const [states2, setStates2] = useState(false);
  const [districts1, setDistricts1] = useState(false);
  const [districts2, setDistricts2] = useState(false);
  const [municiple, setMuniciple] = useState(false);
  const handleClose = () => {
    setShowModal(false);
    setViewData(false);
    setAddReceiverModal(false);
    setErrors(false);
    setProcessId("");
  }
  const handleShow = () => setShowModal(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (processId) {
      const { otp } = e.target;
      let reqData = {
        OTP: otp.value,
        mobileNumber,
        OTPToken: processId.OTPToken
      };
      try {
        const response = await axios.post('/ime/customer/generateOTT', reqData);
        const { Response, Status, Url } = response.data;
        if (Response.Code == "0") {
          if (Status == "OttToken") {
            window.open(Url, '_blank');
          }
          setShowModal(false);
        }
        toast(Response.Message);
      }
      catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
    else {
      const form = e.target;
      let jsonData = {};
      let errorData = {};
      Array.from(form.elements).forEach((item) => {
        if (item.name) {
          if (item.value == "" && item.getAttribute("requiredField")) {
            errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
          }
          jsonData[item.name] = item.value;
        }
      });
      jsonData['dob'] = jsonData['dob'].replace(/-/g, "/");
      //jsonData['photo'] = base64 && base64.photo && base64['photo'];
      //jsonData['id_proof'] = base64 && base64.id_proof && base64['id_proof'];
      if (Object.entries(errorData).length > 0) {
        setErrors(errorData);
      }
      else {
        try {
          let data = { ...jsonData };
          const response = await axios.post('/ime/customer/aadharCustomerRegistration', data);
          const { Response, OTPToken } = response.data;
          if (Response.Code == "0") {
            setProcessId({ ...processId, OTPToken });
          }
          toast(Response.Message);
        } catch (error) {
          if (error?.response?.data?.message) {
            toast(error.response.data.message);
          }
        }
      }
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const { search_by, id_number, mobile } = e.target;
    const isValid = /^\d{10}$/.test(mobile.value);
    if (!isValid) {
      setErrors({ mobile: "Mobile should be 10 number" });
    }
    else {
      setErrors(false);
      let data = {};
      let url = "";
      if (search_by.value == "id") {
        data = {
          type: "id_number",
          mobile_number: id_number.value
        };
        url = '/ime/customer/getEntityStatus';
      }
      else {
        data = {
          type: "mobile",
          mobile_number: mobile.value
        };
        url = '/ime/customer/getEntityStatus';
      }
      try {
        setMobileNumber(data.mobile_number);
        const response = await axios.post(url, data);
        const { Response, Status, IsEligibleForTxn } = response.data;
        if (Response.Code != 0) {
          if (Response.Message == "Customer is not Eligible.") {
            setCustomerStatus("customerIsNotEligible");
          }
          if (Response.Message == "Mobile does not exists.") {
            setCustomerStatus("mobileDoesNotExists");
          }
          toast(Response.Message);
        }
        else {
          if (Status == "RBLUniqueIdentifier") {
            const response = await axios.post('/ime/customer/UniqueIdentifier', { mobileNumber: data.mobile_number || mobileNumber });
            const { Response } = response.data;
            if (Response.Code == "0") {
              captureFinger(data.mobile_number || mobileNumber);
            }
            else {
              if (Response.Message == "Sorry we are unable to process as location permission denied by the user" ||
                Response.Message == "UIDAI Verification is Pending. Please Verify Aadhar Number"
              ) {
                const response = await axios.post('/ime/customer/generateOTT', { mobileNumber: data.mobile_number || mobileNumber });
                const { Response, Status, Url } = response.data;
                if (Response.Code == "0") {
                  //if (Status == "RBLUniqueIdentifier") {
                  window.open(Url, '_blank');
                  //}
                }
                toast(Response.Message);
              }
            }
          }
          if (Status == "BioKyc") {
            captureFinger(data.mobile_number || mobileNumber);
          }
          if (Status == "CustomerOnboarding") {
            const response = await axios.post('/ime/customer/onboarding', { mobileNumber: data.mobile_number || mobileNumber });
            const { Response } = response.data;
            toast(Response.Message);
          }
          if (Status == "OttToken") {
            const response = await axios.post('/ime/customer/generateOTT', { mobileNumber: data.mobile_number || mobileNumber });
            const { Response, Status, Url } = response.data;
            if (Response.Code == "0") {
              //if (Status == "RBLUniqueIdentifier") {
              window.open(Url, '_blank');
              //}
            }
            toast(Response.Message);
          }
          if (Status == "Success" && IsEligibleForTxn == "") {
            toast("Success!");
            // let response = await axios.post("/ime/customer/consent", { mobileNumber: data.mobile_number || mobileNumber });
            // let { Response } = response.data;
            // if (Response.Remarks == "OTP Consent Pending") {
            //   window.open("https://uiduat.rblbank.com/PrepaidCustomerLogin/PPIAgentEkyc.aspx?ref=n4VqHQe13IbA/4uRcwC7/Q==", '_blank');
            // }
            // else {
            //   toast(Response.Message);
            // }
          }
          else if (IsEligibleForTxn == "True") {
            toast("You are eligible for transaction!");
          }
          else {
            //toast(ResponseMessage);
          }
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const encode = (input) => {
    const bytes = new TextEncoder().encode(input);
    const binary = Array.from(bytes).map(b => String.fromCharCode(b)).join('');
    return btoa(binary);
  };

  const captureFinger = async (mobileNumber) => {
    const finalUrl = "https://127.0.0.1:11100/rd/capture";
    const XML = `<?xml version="1.0"?><PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" iType="0" pCount="0" pType="0" format="0" pidVer="2.0" timeout="10000" otp="" wadh="TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=" posh="" env="P" /><CustOpts><Param name="" value="" /></CustOpts></PidOptions>`;
    try {
      $.ajax({
        type: "CAPTURE",
        async: false,
        crossDomain: true,
        url: finalUrl,
        data: XML,
        contentType: "text/xml; charset=utf-8",
        processData: false,
        success: async function (resData) {
          var pid = encode(resData);
          try {
            let response = await axios.post('/ime/customer/enrollment', { mobileNumber, pid: pid });
            const { status, message } = response.data;
            if (!status) {
              toast(message);
            }
            else {
              toast(message);
            }
          }
          catch (error) {
            if (error?.response?.data?.message) {
              toast(error.response.data.message);
            }
          }
        },
        error: function (jqXHR, ajaxOptions, thrownError) {
          toast(getHttpError(jqXHR));
        },
      });
    } catch (error) {
      toast(getHttpError(error));
    }
  };

  const getHttpError = (error) => {
    let err = "Unhandled Exception";
    if (!error.response) {
      err = 'Service Unavailable';
    } else if (error.response.status === 404) {
      err = 'Requested page not found';
    } else if (error.response.status === 500) {
      err = 'Internal Server Error';
    } else if (error.message === 'timeout') {
      err = 'Time out error';
    } else if (error.message === 'abort') {
      err = 'Ajax request aborted';
    } else {
      err = 'Unhandled Error';
    }
    return err;
  };

  const getStateData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/imeremittance/get/state', { country_id: e.target.value });
      const { status } = response.data;
      if (status) {
        if (e.target.name == "country") {
          setIdProof(e.target.value);
          setStates1(response.data.data);
        }
        else {
          setStates2(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getDistrictData = async (e) => {
    deleteError(e);
    try {
      const response = await axios.post('/v2/imeremittance/get/district', { state_id: e.target.value });
      const { status } = response.data;
      if (status) {
        if (e.target.name == "state" || e.target.name == "receiver_state") {
          setDistricts1(response.data.data);
        }
        else {
          setDistricts2(response.data.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getMunicipleData = async (e, idProof) => {
    deleteError(e);
    if (idProof == "NPL") {
      try {
        const response = await axios.post('/v2/imeremittance/get/municiple', { district_id: e.target.value });
        const { status } = response.data;
        if (status) {
          setMuniciple(response.data.data);
        }
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const getData = async () => {
    try {
      const response = await axios.post('/v2/imeremittance/get/banks', { country_id: "NPL" });
      const { status } = response.data;
      if (status) {
        setBankName(response.data.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (currentUser && currentUser.imeMoneyTransfer == false) {
      navigate('/admin/dashboard');
    }
  }, [currentUser]);

  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const deleteError = (e) => {
    const errorKey = e.target.name;
    if (errorKey) {
      const updatedErrors = { ...errors };
      delete updatedErrors[errorKey];
      setErrors(updatedErrors);
    }
  };

  const handleFileChange = (e) => {
    deleteError(e);
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setBase64({ ...base64, [e.target.name]: base64String });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                Search Sender (IME Kyc Money Transfer)
              </h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Search By</label>
                    <select className="form-control" name="search_by" onChange={(e) => setSearchBy(e.target.value)}>
                      <option value="mobile">Mobile Number</option>
                      <option value="id">ID Number</option>
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    {
                      searchBy == "id" ? (
                        <>
                          <label>ID Number</label>
                          <input className="form-control" type="number" name="id_number" required />
                        </>
                      ) : (
                        <>
                          <label>Mobile</label>
                          <input className="form-control" type="number" name="mobile" />
                          <span className="error">{errors && errors?.mobile}</span>
                        </>
                      )
                    }
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {
                customerStatus && (
                  customerStatus == "customerIsNotEligible" ? (
                    <>
                      <div>Customer is not Eligible</div>
                    </>
                  ) : customerStatus == "mobileDoesNotExists" ? (
                    <>
                      <div>Customer Does Not Exists</div>
                      <Button variant="primary" onClick={handleShow}>
                        Add Customer
                      </Button>
                    </>
                  ) : ""
                )
              }
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose} centered size={processId == "" ? 'xl' : 'sm'} backdrop="static">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Create Aadhaar Customer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              processId == "" ? (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <label>Mobile Number</label>
                        <input className="form-control" type="number" name="mobile_number" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.mobile_number}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Full Name</label>
                        <input className="form-control" type="text" name="fullName" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.fullName}</span>
                      </div>
                      {/* <div className="col-lg-4 col-md-4">
                        <label>First Name</label>
                        <input className="form-control" type="text" name="first_name" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.first_name}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Middle Name</label>
                        <input className="form-control" type="text" name="middle_name" />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Last Name</label>
                        <input className="form-control" type="text" name="last_name" />
                      </div> */}
                      <div className="col-lg-4 col-md-4">
                        <label>Martial Status</label>
                        <select className="form-control" name="marital_status" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="1901">Married</option>
                          <option value="1902">Un Married</option>
                        </select>
                        <span className="error">{errors && errors?.marital_status}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Gender</label>
                        <select className="form-control" name="gender" onChange={deleteError} requiredField="true">
                          <option value="">Select Gender</option>
                          <option value="1801">Male</option>
                          <option value="1802">Female</option>
                          <option value="1803">Other</option>
                        </select>
                        <span className="error">{errors && errors?.gender}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Date of birth</label>
                        <input className="form-control" type="date" name="dob" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.dob}</span>
                      </div>
                      {/* <div className="col-lg-4 col-md-4">
                        <label>Email</label>
                        <input className="form-control" type="email" name="email" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.email}</span>
                      </div> */}
                      {/* <div className="col-lg-4 col-md-4">
                        <label>Occupation</label>
                        <select className="form-control" name="occupation" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {
                            Object.entries(occupation).map(([index, occ]) => (
                              <option value={index}>{occ}</option>
                            ))
                          }
                        </select>
                        <span className="error">{errors && errors?.occupation}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Source of Fund</label>
                        <select className="form-control" name="source_of_fund" onChange={deleteError} requiredField="true">
                          <option value="">--Select--</option>
                          {
                            Object.entries(sourceOfFund).map(([index, sof]) => (
                              <option value={index}>{sof}</option>
                            ))
                          }
                        </select>
                        <span className="error">{errors && errors?.source_of_fund}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Estimate Annual Income</label>
                        <select className="form-control" name="estimate_annual_income" onChange={deleteError} requiredField="true">
                          <option value="1">Rs. 0.00 lacs to Rs. 2.00 Lacs</option>
                          <option value="2">Rs. 2.00 Lacs to Rs. 5 Lacs</option>
                          <option value="3">Rs. 5 Lacs to Rs. 10 Lacs</option>
                          <option value="4">More than Rs. 10 Lacs</option>
                        </select>
                        <span className="error">{errors && errors?.estimate_annual_income}</span>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <p>Address</p>
                      <div className="col-lg-4 col-md-4">
                        <label>Country</label>
                        <select className="form-control" name="country" onChange={getStateData} requiredField="true">
                          <option value="">--Select--</option>
                          <option value="IND">India</option>
                          <option value="NPL">Nepal</option>
                        </select>
                        <span className="error">{errors && errors?.country}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>State</label>
                        <select className="form-control" name="state" onChange={getDistrictData} requiredField="true">
                          <option value="">--Select--</option>
                          {states1 && states1.map((state, index) => (
                            <option value={state.state_id}>
                              {state.State}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.state}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>District</label>
                        <select className="form-control" name="district" onChange={(e) => getMunicipleData(e, idProof)} requiredField="true">
                          <option value="">--Select--</option>
                          {districts1 && districts1.map((district, index) => (
                            <option value={district.district_id}>
                              {district.district}
                            </option>
                          ))}
                        </select>
                        <span className="error">{errors && errors?.district}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Pin Code</label>
                        <input className="form-control" type="number" name="pin_code" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.pin_code}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>Address</label>
                        <input className="form-control" type="text" name="address" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.address}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <p>Identity Proof</p>
                      <div className="col-lg-4 col-md-4">
                        <label>Aadhaar Number</label>
                        <input className="form-control" type="text" name="aadhar_number" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.aadhar_number}</span>
                      </div>
                      {/* <div className="col-lg-4 col-md-4">
                        <label>Photo</label>
                        <input className="form-control" type="file" name="photo" onChange={handleFileChange} requiredField="true" />
                        <span className="error">{errors && errors?.photo}</span>
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <label>ID Proof</label>
                        <input className="form-control" type="file" name="id_proof" onChange={handleFileChange} requiredField="true" />
                        <span className="error">{errors && errors?.id_proof}</span>
                      </div> */}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <label>OTP</label>
                        <input className="form-control" type="number" name="otp" onChange={deleteError} requiredField="true" />
                        <span className="error">{errors && errors?.otp}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {processId == "" ? 'Send OTP' : 'Create Customer'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default ImeMoneyKycTransfer;
